/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';
import {TripBoardButton} from '@homeaway/react-trip-board-button';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';
import Experiment from '@homeaway/react-experiment';

import {State as ReduxState} from '../../reducers';

import {ListingShape as HitListingShape} from '../Hit/Hit';

export type StateProps = {
    isMobile?: boolean;
    isLoggedIn?: boolean;
};

type Props = {
    listing: HitListingShape;
    isMapHit?: boolean;
} & StateProps;

const TripBoardComponent = ({
    listing: {propertyMetadata, images, listingId, averageRating, reviewCount},
    isMapHit = false,
    isMobile,
    isLoggedIn
}: Props) => (
    <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
        {({logExperiment}) => (
            <TripBoardButton
                expandedButton={!isMobile}
                headline={(propertyMetadata && propertyMetadata.headline) || ''}
                listingId={listingId}
                averageRating={averageRating}
                reviewCount={reviewCount}
                tabIndex={-1}
                thumbnailUrl={images && images[0] && images[0].c9_uri}
                useNativeEventListener={isMapHit}
                redOnHover
                actionlocation={isMapHit ? 'search_map' : 'search'}
                {...(!isLoggedIn && {onClick: logExperiment})}
            />
        )}
    </Experiment>
);

export const mapStateToProps = (state: ReduxState): StateProps => {
    const {
        system,
        user: {isLoggedIn}
    } = state;
    const {isMobile, isTablet} = system;

    return {
        isMobile: isMobile && !isTablet,
        isLoggedIn
    };
};

export default connect(mapStateToProps)(TripBoardComponent);
